export enum ClientStateStatus {
  Initial = 'initial',
  Loading = 'loading',
  SuccessFullyLoaded = 'successfullyLoaded',
  FailedToLoad = 'failedToLoad',
}
